import { useTranslate } from '~/i18n';
import { ArrowDown, TranslationIcon } from '~/svgs';
import { Menu } from '@headlessui/react';
import LangSwitcher from './lang-switcher';
import cn from 'classnames';
import { useRef } from 'react';
export const languages: Record<string, { title: string; short: string; route: string }> = {
   en: {
      title: 'English',
      short: 'En',
      route: 'en',
   },
   ar: {
      title: 'العربية',
      short: 'Ar',
      route: 'ar',
   },
   zh: {
      title: '中文',
      short: 'Zh',
      route: 'zh',
   },
};

interface LangSelectorProps {
   black_icon?: boolean;
   titleStyles?: string;
   showShort?: boolean;
   hideChinese?: boolean;
}

export const LangSelector = ({
   black_icon,
   titleStyles,
   showShort = false,
   hideChinese = false,
}: LangSelectorProps) => {
   const { lang } = useTranslate();
   const entries = Object.entries(languages);
   const buttonRef = useRef<any>(null);
   const filteredEntries = hideChinese ? entries.filter(([key]) => key !== 'zh') : entries;

   return (
      <Menu as="div" className="relative">
         <Menu.Button
            ref={buttonRef}
            className="flex items-center focus:outline-none focus:opacity-70">
            <div className="flex items-center h-10">
               <TranslationIcon
                  width="20px"
                  height="20px"
                  className={!black_icon ? '[&>path]:fill-white' : ''}
               />
            </div>
            <span
               className={cn(
                  'ltr:ml-1.5 rtl:mr-1.5 text-sm',
                  !black_icon && 'text-white',
                  titleStyles && titleStyles
               )}>
               {showShort && lang != 'ar' ? languages[lang].short : languages[lang].title}
            </span>
            <ArrowDown
               className={cn(
                  'transform scale-[0.5] ltr:ml-1 rtl:mr-1',
                  !black_icon && '[&>path]:fill-white'
               )}
            />
         </Menu.Button>

         <Menu.Items
            as="ul"
            className="absolute w-40 mt-2 overflow-hidden text-black bg-white rounded ltr:left-0 rtl:right-0 focus:outline-none shadow-base z-[2]">
            {filteredEntries.map(([lang, { short, title, route }]) => (
               <Menu.Item key={lang} as="li" className="border-b last:border-b-0">
                  {({ active, close }) => (
                     <LangSwitcher
                        className={cn(
                           'block w-full p-2 text-sm hover:bg-gray-50 focus:bg-gray-50',
                           active && 'bg-gray-50'
                        )}
                        text={
                           <div className="flex items-center text-xs pointer-events-none text-black/70">
                              <span className="text-black">{short}</span>
                              <span className="mx-1">-</span>
                              <div>{title}</div>
                           </div>
                        }
                        href={`/${route}`}
                        closeSelector={close}
                     />
                  )}
               </Menu.Item>
            ))}
         </Menu.Items>
      </Menu>
   );
};
